export type Config = {
   auth_type: string;
   auth_path: string;
   auth_skip: boolean;
   base_path: string;
   cdna_url: string;
   csrf_token: string;
   en_url?: string;
   logout_url: string;
   offer_id: string;
   region?: string;
   require_tenancy?: boolean;
   clientId: string;
   token?: string;
};

export type T = Config;

export const get = (): Config => ({
   auth_skip: window.platformUI.authSkip,
   auth_type: window.platformUI.auth.authType,
   auth_path: window.platformUI.auth.authorizePath,
   base_path: window.platformUI.config.basePath,
   cdna_url: window.platformUI.auth.cdnaUrl,
   csrf_token: window.platformUI.csrfToken,
   en_url: window.platformUI.auth.enUrl,
   logout_url: window.platformUI.auth.logoutPath,
   offer_id: window.platformUI.offerId,
   region: window.platformUI.region,
   require_tenancy: window.platformUI.auth.requireTenancy,
   clientId: window.platformUI.auth.clientId,
});

export const useConfig = (): Config => get();
